// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

export function sessionDeleteAll() {
  return http<unknown>({
    url: "/api/v1/sessions/",
    method: "delete",
  })
}
